import hasFeature from 'modules/core/lib/hasFeature'

import type TemplateWeeks from 'modules/shift_management/store/internal/collections/TemplateWeeks'

import { Shift } from './types'

/**
 * @deprecated Before using this method, consider using the `shift.displayName`
 * we are trying to move away from using mobx-rest and use GraphQL instead.
 */
export const getTemplateTitle = (shift: Shift, templateWeeks: TemplateWeeks): string => {
  if (!shift.templateWeekId) return ''

  const templateWeek = templateWeeks.findById(shift.templateWeekId)
  const templateName = templateWeek && `${templateWeek.templateName} - ${templateWeek.name}`
  const canUseColors = hasFeature('shift_management_colours_for_shifts')
  const showTemplateWeekTitle = canUseColors && templateName

  return showTemplateWeekTitle ? templateName : ''
}
